import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "container", "tip"]

  connect() {
    this.deferredPrompt = null
    this.handleDeferredPrompt = this.handleDeferredPrompt.bind(this)
    this.handleAppInstalled = this.handleAppInstalled.bind(this)
    this.handleViewportChange = this.handleViewportChange.bind(this)
    this.mobileMenuQuery = window.matchMedia("(max-width: 720px)")

    this.hideButton()
    this.updateIOSTip()
    this.handleDeferredPrompt()

    window.addEventListener("hitl:beforeinstallprompt", this.handleDeferredPrompt)
    window.addEventListener("appinstalled", this.handleAppInstalled)
    this.mobileMenuQuery.addEventListener("change", this.handleViewportChange)
  }

  disconnect() {
    window.removeEventListener("hitl:beforeinstallprompt", this.handleDeferredPrompt)
    window.removeEventListener("appinstalled", this.handleAppInstalled)
    this.mobileMenuQuery.removeEventListener("change", this.handleViewportChange)
  }

  handleDeferredPrompt() {
    if (!this.canOfferInstallPrompt) return

    this.deferredPrompt = window.HITLInstallPrompt?.event
    if (!this.deferredPrompt) return

    this.showButton()
  }

  handleAppInstalled() {
    this.deferredPrompt = null
    if (window.HITLInstallPrompt) window.HITLInstallPrompt.event = null
    this.hideButton()
    this.hideTip()
  }

  handleViewportChange() {
    if (this.canOfferInstallPrompt) return this.handleDeferredPrompt()

    this.deferredPrompt = null
    this.hideButton()
  }

  async install() {
    if (!this.deferredPrompt) return

    this.deferredPrompt.prompt()
    await this.deferredPrompt.userChoice
    this.deferredPrompt = null
    if (window.HITLInstallPrompt) window.HITLInstallPrompt.event = null
    this.hideButton()
  }

  updateIOSTip() {
    if (this.isIOSSafari && !this.isStandalone) this.showTip()
    else this.hideTip()
  }

  showButton() {
    if (this.hasButtonTarget) this.buttonTarget.hidden = false
    this.updateContainer()
  }

  hideButton() {
    if (this.hasButtonTarget) this.buttonTarget.hidden = true
    this.updateContainer()
  }

  showTip() {
    if (this.hasTipTarget) this.tipTarget.hidden = false
    this.updateContainer()
  }

  hideTip() {
    if (this.hasTipTarget) this.tipTarget.hidden = true
    this.updateContainer()
  }

  updateContainer() {
    if (!this.hasContainerTarget) return

    const buttonHidden = !this.hasButtonTarget || this.buttonTarget.hidden
    const tipHidden = !this.hasTipTarget || this.tipTarget.hidden
    this.containerTarget.hidden = buttonHidden && tipHidden
  }

  get isIOSSafari() {
    const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)

    return isIOSDevice &&
      /Safari/.test(navigator.userAgent) &&
      !/CriOS|FxiOS|EdgiOS/.test(navigator.userAgent)
  }

  get isStandalone() {
    return window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true
  }

  get canOfferInstallPrompt() {
    return this.mobileMenuQuery.matches && !this.isStandalone && this.hasButtonTarget
  }
}
